export default "__VITE_ASSET__CzEMkyPH__"